import * as React from 'react';
import { useTheme } from '../Theme/Theme';
import { style } from './style';
import { Row } from '../..';
export const Breadcrumb = (props) => {
    const theme = useTheme();
    const css = style(theme);
    const children = Array.isArray(props.children)
        ? props.children
        : [props.children];
    return (React.createElement(Row, { gutter: [0, 0], className: css, alignItems: "center" }, children.map((v, index) => (React.createElement(React.Fragment, { key: `breadcrumb-${index}` },
        React.createElement("li", { key: `bread-${index}` }, v),
        index !== children.length - 1 && (React.createElement("li", { className: "breadcrumb-seperator", key: `breadcrumb-seperator-${index}` }, props.seperator)))))));
};
Breadcrumb.defaultProps = {
    seperator: '/',
    children: [],
};
//# sourceMappingURL=Breadcrumb.js.map